module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', _vm._l((_vm.utils.getSectionNamesBySorted(_vm.layoutHeaderConfig.sections)), function(item, key) {
    return _c('PageSection', {
      key: key,
      attrs: {
        "section-name": item,
        "config": _vm.layoutHeaderConfig.sections,
        "data-set": _vm.layoutDataSet
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10cf1a82","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/header/Header.vue
// module id = 381831dcdf22c4579ac0
// module chunks = 18